import React from "react";
import { AppProvider } from "./src/context";

import "@styles/global.css";

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);
